import i18n from "i18next";
import Fetch from "i18next-fetch-backend";
import { initReactI18next } from "react-i18next";
import { API_DOMAIN } from "./Constants";

i18n
  .use(initReactI18next)
  .use(Fetch)
  .init(
    {
      fallbackLng: false,
      preload: false,
      wait: true,
      keySeparator: false, // Allow usage of dots in keys
      backend: {
        loadPath: `${API_DOMAIN}/service/masterdata-service/2.0/translationsList/`,
        addPath: `${API_DOMAIN}/service/masterdata-service/2.0/translationsList/`,
        parse: function(data) {
          return JSON.parse(data).translationObjectlist;
        },
        requestOptions: {
          method: "POST"
        }
      },
      react: {
        useSuspense: false
      },
      debug: false
    },
    (err, _t) => {
      if (err) {
        return;
      }
    }
  );

export default i18n;
